import React, { ReactNode } from 'react';
import { styled } from 'styled-components';


export enum BannerLevel {
  INFO = 1,
  WARNING,
  ERROR
}

export type IUBannerConfig = {
  id?: string;
  contents: ReactNode;
  level: BannerLevel;
  duration?: number;
}

const Banner = ({config, onClose}: {config: IUBannerConfig, onClose: () => void}) => {
  let bgColor: string;
  let borderColor: string;
  if (config.level === BannerLevel.ERROR) {
    bgColor = '#fe3030';
    borderColor = '#851717';
  } else if (config.level === BannerLevel.WARNING) {
    bgColor = '#e9f005';
    borderColor = '#6c7003';
  } else {
    bgColor = '#30c7fe';
    borderColor = '#14566e';
  }

  return <BannerDiv $bgColor={bgColor} $borderColor={borderColor}>
    {config.contents}
    <CloseIcon onClick={onClose}>
      ✖️
    </CloseIcon>
  </BannerDiv>;
}

const BannerDiv = styled.div<{$bgColor: string, $borderColor: string}>`
  width: 100%;
  margin: 5px 0;
  padding: 5px 10px;
  color: black;
  background-color: ${({$bgColor}) => $bgColor};
  font-size: 20px;
  border: 1px solid ${({$borderColor}) => $borderColor};
  border-radius: 5px;
  position: absolute;
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
`;

const CloseIcon = styled.div`
  cursor: pointer;
`;

export default Banner;
